import { EditPackagePageComponent } from './packages/pages/edit-package-page/edit-package-page.component';
import { Route } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const MARKETPLACE_ROUTES: Route[] = [
  {
    path : RoutesConstants.MARKETPLACE_PACKAGES_PAGE_URL ,
    component : RouterComponent,
    children : [
      {
        path: '',
        loadComponent: () =>
          import('./packages/pages/packages-page/marketplace-page.component').then((x) => x.MarketplacePageComponent),
        data: {
          breadcrumb: {
            label: 'STORE',
            icon: 'store',
          },
          permissions: [Permissions.Setting_Package],
        },
      },
      {
        path: RoutesConstants.PACKAGE_EDITOR_PAGE_URL + '/:id',
        loadComponent: () =>
          import('./packages/pages/edit-package-page/edit-package-page.component').then((x) => x.EditPackagePageComponent),
        data: {
          permissions: [Permissions.Setting_Package],
        },
      },
      {
        path: RoutesConstants.PACKAGE_ADD_PAGE_URL,
        loadComponent: () =>
          import('./packages/pages/add-package-page/add-package-page.component').then((x) => x.PackageEditorComponent),
        data: {
          breadcrumb: {
            label: 'PACKAGES',
            icon: 'local_mall',
          },
          permissions: [Permissions.Setting_Package],
        },
      },
    ]
  },



  {
    path: RoutesConstants.MARKETPLACE_PRODUCTS_PAGE_URL,
    loadComponent: () =>
      import('./products/pages/products-page/products-page.component').then((x) => x.ProductsPageComponent),
    data: {
      breadcrumb: {
        label: 'PRODUCTS',
        icon: 'apps',
      },
      permissions: [Permissions.Setting_Products],
    },
  },
];

for (const route of MARKETPLACE_ROUTES) {
  route.canActivate = [PermissionGuard];
}
